import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { History, ExternalLink } from "lucide-react";
import { api } from "../api";
import { fmtDate, scoreColor } from "../lib/labels";

export default function HistoryPage() {
  const [queries, setQueries] = useState(null);

  useEffect(() => {
    api.get("/my-queries").then((r) => setQueries(r.data)).catch(() => setQueries([]));
  }, [api]);

  return (
    <div className="min-h-screen pt-24 pb-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3">
          <History className="w-6 h-6 text-cyan-300" />
          <h1 className="text-2xl sm:text-3xl font-bold text-white">Geçmiş Sorgularım</h1>
        </div>
        <p className="mt-2 text-sm text-slate-400">Daha önce sorguladığınız araçların listesi.</p>
        <p data-testid="queries-ttl-note" className="mt-2 text-xs text-amber-300/80">Bu sorgulama kaydı 48 saat boyunca görüntülenebilir ve süre sonunda otomatik olarak silinir.</p>

        <div className="mt-8 rounded-2xl border border-white/10 bg-slate-900/60 backdrop-blur-xl overflow-hidden">
          {queries === null ? (
            <div className="p-12 flex justify-center">
              <div className="w-8 h-8 border-2 border-cyan-400 border-t-transparent rounded-full animate-spin" />
            </div>
          ) : queries.length === 0 ? (
            <div className="p-12 text-center">
              <p data-testid="queries-empty" className="text-slate-400">Henüz sorgulama yapmadınız.</p>
              <Link to="/" className="inline-block mt-4 text-cyan-300 hover:text-cyan-200 text-sm font-semibold">
                İlk sorgunuzu yapın →
              </Link>
            </div>
          ) : (
            <div className="overflow-x-auto">
              <table data-testid="queries-table" className="w-full text-sm">
                <thead>
                  <tr className="border-b border-white/10 text-left text-xs uppercase tracking-wider text-slate-500">
                    <th className="px-6 py-4">Şasi No</th>
                    <th className="px-6 py-4">Araç</th>
                    <th className="px-6 py-4">Skor</th>
                    <th className="px-6 py-4">Tarih</th>
                    <th className="px-6 py-4 text-right">Rapor</th>
                  </tr>
                </thead>
                <tbody>
                  {queries.map((q) => (
                    <tr key={q.id} className="border-b border-white/5 hover:bg-slate-800/40 transition-colors">
                      <td className="px-6 py-4 font-mono-vin text-cyan-300 text-xs sm:text-sm">{q.vin}</td>
                      <td className="px-6 py-4 text-slate-200">{q.vehicle}</td>
                      <td className="px-6 py-4">
                        <span className="font-bold" style={{ color: scoreColor(q.score) }}>{q.score}</span>
                      </td>
                      <td className="px-6 py-4 text-slate-400 whitespace-nowrap">{fmtDate(q.created_at)}</td>
                      <td className="px-6 py-4 text-right">
                        <Link data-testid={`open-report-${q.vin}`} to={`/rapor/${q.vin}`}
                          className="inline-flex items-center gap-1.5 text-cyan-300 hover:text-cyan-200 font-semibold text-xs sm:text-sm">
                          Aç <ExternalLink className="w-3.5 h-3.5" />
                        </Link>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
